import Heading from '@deliveroo/tools-component-library/dist/components/Heading';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import PasswordResetContainer from 'lib/components/PasswordReset';
import withI18n from 'lib/hocs/withI18n';
import styles from './styles.scss';

class Welcome extends Component {
  static propTypes = {
    token: PropTypes.string.isRequired,
    i18n: withI18n.TYPE.isRequired,
  };

  static getInitialProps({ query }) {
    return { token: query.token };
  }

  render() {
    const { token, i18n } = this.props;

    return (
      <div className={styles.resetCard}>
        <PasswordResetContainer token={token}>
          <Heading level={3}>{i18n.gettext('welcome.title')}</Heading>
        </PasswordResetContainer>
      </div>
    );
  }
}

export default withI18n(Welcome);
